<template>
  <div>
    <div id="ReasignacionDeOperadores_div" class="w-100 px-5 py-4">
      <div id="TituloReasignacionDeOperadore_div">
        <h1>REASIGNACIÓN DE OPERADORES</h1>
        <h3>Control de asignación de operadores</h3>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaSesionesDeLasAudiencias"></FiltrosDeBusqueda>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <h4>Sesiones de audiencias encontradas</h4>
            <h6>Cambie el operador que trabajara la sesión de la audiencia</h6>
            <hr />
            <div id="PanelDeAudienciasPendientesPendientes_table" class="table-responsive">
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Fecha y Hora</th>
                    <th class="text-center">Tipo de Documento</th>
                    <th class="text-center">Consecutivo</th>
                    <th class="text-center">Partido Judicial</th>
                    <th class="text-center">Juzgado</th>
                    <th class="text-center">Materia</th>
                    <th class="text-center">Tipo de Audiencia</th>
                    <th class="text-center">Operador</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="sesionesDeLasAudiencias.length <= 0">
                    <td colspan="12" class="text-center">No existen registros de sesiones de audiencias</td>
                  </tr>
                  <tr v-else v-for="sesionDeLaAudiencia in sesionesDeLasAudiencias" :key="sesionDeLaAudiencia.SesionDeLaAudienciaId">
                    <td v-html="obtenFechaDeAudienciaConFormato(sesionDeLaAudiencia.Audiencia.FechaAudiencia)" style="width: 100px;"></td>
                    <td>{{sesionDeLaAudiencia.Audiencia.TipoDocumento.Nombre}}</td>
                    <td class="text-center">{{sesionDeLaAudiencia.Audiencia.Consecutivo}}</td>
                    <td>{{sesionDeLaAudiencia.Audiencia.PartidoJudicial.Nombre}}</td>
                    <td>{{sesionDeLaAudiencia.Audiencia.Area.Nombre}}</td>
                    <td>{{sesionDeLaAudiencia.Audiencia.Materia.Nombre}}</td>
                    <td>{{sesionDeLaAudiencia.Audiencia.TipoAudiencia.Nombre}}</td>
                    <td>
                      <C001OperadoresDeSala v-on:valorParaElPadre="cambioDeOperador" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Ninguno" :idDelInput="'' + sesionDeLaAudiencia.SesionDeLaAudienciaId" :parametros="{}" :valorDefinido="sesionDeLaAudiencia.Audiencia.Usuario_OperadorDeSala.IdUsuario" :key="sesionDeLaAudiencia.SesionDeLaAudienciaId"></C001OperadoresDeSala>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import router from '@/router/index'
  import axios from 'axios'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'

  export default {
    components: {
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda,
      C001OperadoresDeSala: catalogos.Cuentas.C001OperadoresDeSala
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },
          { catalogoId: enumeraciones.catalogos.TiposEstatusDeLaAudiencia, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Todos },
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Consecutivo },
          { catalogoId: enumeraciones.catalogos.Salas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.OperadoresDeSala, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione }
        ],
        sesionesDeLasAudiencias: []
      }
    },
    mounted() {
      this.cargaSesionesDeLasAudiencias();
    },
    methods: {
      obtenFechaDeAudienciaConFormato: function(fechaDeAudiencia) {
        return moment(fechaDeAudiencia).format("DD-MM-YYYY <br /> h:mm a")
      },
      cargaSesionesDeLasAudiencias: function() {
        // if(this.validaParametrosBusqueda())
        // {
          comun.SeEstaCargandoInformacion(true);

          const parametros = {
            FechaInicial: this.$store.state.Comun_FechaInicial,
            FechaFinal: this.$store.state.Comun_FechaFinal,
            TipoEstatusDeLaAudienciaId: this.$store.state.Forseti_Catalogos_001TipoEstatusDeAudienciaId,
            PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales.filtroDeBusqueda_PartidoJudicial,
            MateriaId: this.$store.state.PJ_Catalogos_002Materias.filtroDeBusqueda_Materia,
            AreaId: this.$store.state.PJ_Catalogos_001Areas.filtroDeBusqueda_Area,
            SalaId: this.$store.state.PJ_Catalogos_020Salas.filtroDeBusqueda_Sala,
            EsPrueba: this.enumeraciones.EsPrueba
          }

          axios.post(
            api.conexion + api.Forseti.sistema.administracion.reasignaciondeoperadores.ObtenSesionesDeLasAudiencias,
            parametros,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
              if(respuesta.data.SiHayError){
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                this.sesionesDeLasAudiencias = [];
              } else {
                this.sesionesDeLasAudiencias = respuesta.data.SesionesDeLasAudiencias;
              }
    
              comun.SeEstaCargandoInformacion(false);
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);
              this.sesionesDeLasAudiencias = [];
            });
        //}
      },
      cambioDeOperador(datos) {
        comun.SeEstaCargandoInformacion(true);

        const parametros = {
          SesionDeLaAudienciaId: parseInt(datos.target.id),
          UsuarioId_Operador: parseInt(datos.target.value),
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.administracion.reasignaciondeoperadores.GuardarOperadorDeLaSesion,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);

              this.sesionesDeLasAudiencias.forEach((elemento, index) => {
                if (element.SesionDeLaAudienciaId == parametros.SesionDeLaAudienciaId) {
                  Vue.set(this.sesionesDeLasAudiencias, index, element);
                }
              });
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              comun.SeEstaCargandoInformacion(false);
            } else {
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.cargaSesionesDeLasAudiencias();
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      validaParametrosBusqueda(){
        if(this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione un Partido Judicial.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione una Materia.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione un Juzgado.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_020Salas['filtroDeBusqueda_Sala'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione una Sala.", null, null);
          return false
        };

        return true;
      }
    }
  }
</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }

  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Administracion/ReasignacionDeOperadores/PanelDeAudiencias.vue